import { render, staticRenderFns } from "./AddComent.vue?vue&type=template&id=28c03c44&scoped=true&"
import script from "./AddComent.vue?vue&type=script&lang=js&"
export * from "./AddComent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c03c44",
  null
  
)

export default component.exports